import { Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "../../components/dashboard/DashBoard";
import Report from "../report/Report";
import NotFound from "../../components/layout/NotFound";
import GetdModel from "../../components/device/GetdModel";
import { connect } from "react-redux";
import SearchModel from "../../components/device/SearchModel";
import SearchDevice from "../../components/device/SearchDevice";
import Statistics from "../../components/dashboard/Statistics";
import ProductMetrics from "../../components/dashboard/ProductMetrics";
import FeedbackStatistics from "../../components/dashboard/FeedbackStatistics";
import FotaJobs from "../../components/dashboard/FotaJobs";
import FirmwareInfo from "../report/FirmwareInfo";
import PrivateRoute from "../../components/routing/PrivateRoute";
import UserInfoPage from "../layout2/pages/UserInfoPage";
import NavBar from "./components/NavBar";
import FeedbackPage from "./pages/FeedbackPage";
import MetricsCharts from "./pages/MetricsChart";
import ManufacturedDevicesPage from "./pages/ManufacturedDevciesPage";
import DeviceFirmware from "../device/DeviceFirmware/Firmware";

import AddNewDeviceModel from "../../components/device/AddNewDeviceModel";

import IDUEEPROMConfig from "../../components/device/IDUEEPROMConfig/IDUConfig";
import customConfig from "../../config";

import QRCode from "./../qrcode/qrcode";
import DeviceDealerMgmt from "../../components/deviceDealerMgmt/deviceDealerMgmt";

import LineTestUserSearchDevice from "./../LineTestUser/SearchDevice";
import NotificationManagement from "../notificationManagement/index";
import InAppNotificationPage from "../../pages/InAppNotificationPage";
import CreateNotificationPage from "../../pages/CreateNotificationPage";
import EditNotificationPage from "../../pages/EditNotificationPage";
import ViewNotificationPage from "../../pages/ViewNotificationPage";
import DACStatistics from "../device/DACStatistics/DACStatistics";
import Settings from "./pages/Settings";
import MatterCD from "../matterCD/MatterCD";
import LoyaltySpecPage from "../../pages/LoyaltySpecPage";
import SmartRoomDashboardPage from "../../pages/SmartRoomDashboardPage";
import PermissionManagementPage from "../../pages/PermissionManagementPage";
import Landing from "../landing/Landing";
import AssetManagement from "../assetManagement/AssetManagement";

const Layout1Routes = ({
  isAuthenticated,
  userLevel,
  userRoles,
  tenantInfo,
}) => {
  /**
   * Move role logic OUTSIDE JSX
   */
  const getDashboardComponent = () => {
    if (userRoles?.includes(customConfig.roleLineTestUser))
      return <LineTestUserSearchDevice />;

    if (
      (userLevel === 0 && userRoles?.includes(customConfig.roleFactoryAdmin)) ||
      userRoles?.includes(customConfig.roleFieldOperator)
    )
      return <SearchDevice />;

    return <UserInfoPage />;
  };

  return (
    <section
      className={` ${tenantInfo.primaryColor
        ? tenantInfo.primaryColor +
        "-theme " +
        tenantInfo.secondaryColor +
        "-theme-secondary"
        : "dark-blue-theme lime-theme-secondary"
        }`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      {isAuthenticated ? (
        <div style={{ flexShrink: 0 }}>
          <NavBar />
        </div>
      ) : null}

      <main style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <Routes>
          {/* ================= PROTECTED ROUTES ================= */}
          <Route element={<PrivateRoute />}>
            <Route path="/landing" element={<Landing />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/smartRoomDashboard" element={<SmartRoomDashboardPage />} />
            <Route path="/permissionManagement" element={<PermissionManagementPage />} />
            <Route path="/metricsChart" element={<MetricsCharts />} />
            {/* Dynamic dashboard based on role */}
            <Route path="/dashboard" element={getDashboardComponent()} />
            {/* <Route
              path="/dashboard"
              element={
                userRoles?.includes(customConfig.roleLineTestUser) ? (
                  <LineTestUserSearchDevice />
                ) : (userLevel === 0 &&
                    userRoles?.includes(customConfig.roleFactoryAdmin)) ||
                  userRoles?.includes(customConfig.roleFieldOperator) ? (
                  <SearchDevice />
                ) : (
                  <UserInfoPage />
                )
              }
            /> */}

            <Route
              path="/dashboardBack"
              element={<Dashboard showDetail={true} />}
            />

            {userLevel > 0 && (
              <Route path="/searchDevice" element={<SearchDevice />} />
            )}

            <Route path="/device" element={<GetdModel />} />

            <Route path="/deviceDetail" element={<SearchModel />} />
            <Route path="/deviceDetail/:modelNum" element={<SearchModel />} />

            <Route path="/report/:homeId" element={<Report />} />
            <Route path="/statistics" element={<Statistics />} />
            <Route path="/productMetrics" element={<ProductMetrics />} />
            <Route path="/feedback-statistics" element={<FeedbackStatistics />} />
            
            {/* Making it comment out as per discussion. */}
            {/* <Route path="/fotaJobs" element={<FotaJobs />} /> */}

            <Route path="/firmwareInfo" element={<FirmwareInfo />} />
            <Route
              path="/manufacturedDevices"
              element={<ManufacturedDevicesPage />}
            />

          {/* The LoyaltySpec feature has been temporarily commented out because the corresponding backend services are not yet available in the 
              staging environment. As part of the release from develop to staging, we have disabled it for now. The feature will be enabled once the 
              backend services are deployed and ready. */}
            {/* <Route path="/loyaltySpecs" element={<LoyaltySpecPage />} /> */}
            
            <Route path="/deviceFirmware" element={<DeviceFirmware />} />
            <Route path="/addNewDeviceModel" element={<AddNewDeviceModel />} />
            <Route path="/idueepromConfig" element={<IDUEEPROMConfig />} />
            <Route path="/qrcode" element={<QRCode />} />
            <Route path="/deviceDealer" element={<DeviceDealerMgmt />} />
            <Route path="/notification" element={<NotificationManagement />} />
            <Route path="/inapp-notifications" element={<InAppNotificationPage />} />
            <Route path="/inapp-notifications/create" element={<CreateNotificationPage />} />
            <Route
              path="/inapp-notifications/edit/:notificationId"
              element={<EditNotificationPage />}
            />
            <Route
              path="/inapp-notifications/view/:notificationId"
              element={<ViewNotificationPage />}
            />
            <Route
              path="/app-support/in-app-notifications"
              element={<Navigate to="/inapp-notifications" replace />}
            />
            <Route
              path="/app-support/in-app-notifications/create"
              element={<Navigate to="/inapp-notifications/create" replace />}
            />
            <Route
              path="/app-support/in-app-notifications/edit/:notificationId"
              element={<Navigate to="/inapp-notifications/edit/:notificationId" replace />}
            />
            <Route
              path="/inAppNotifications"
              element={<Navigate to="/inapp-notifications" replace />}
            />
            <Route path="/DACStatistics" element={<DACStatistics />} />
            <Route path="/MatterCD" element={<MatterCD />} />
            <Route path="/assetManagement" element={<AssetManagement />} />
          </Route>

          {/* ================= PUBLIC ROUTES ================= */}
          <Route path="/pageNotFound" element={<NotFound />} />

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/pageNotFound" replace />} />
        </Routes>
      </main>
    </section>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  userRoles: state.auth.userRoles,
  userLevel: state.auth.userLevel,
  tenantInfo: state.tenant.tenantInfo,
});
export default connect(mapStateToProps, {})(Layout1Routes);
